





































































import Vue from 'vue';
import { RoleService } from '@/services/RoleService';
import { RoleModel, RoleCopyModel } from '@/types/models/role';
import { EntityType } from '@/types';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { FormFieldValidation, ModalHelpers } from '@/mixins';

export default Vue.extend({
  name: 'AddRole',
  mixins: [FormFieldValidation, ModalHelpers],
  props: {
    isCopy: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      role: {} as RoleModel,
      isLoading: false
    };
  },
  methods: {
    onSubmit() {
      this.isLoading = true;
      if (this.isCopy) {
        this.copyRole();
      } else {
        this.createRole();
      }
    },
    createRole(this: any) {
      RoleService.createRoleAsync(this.role)
        .then((response) => {
          SnotifyConfiguration.showSuccess('Role added successfully.');
          this.setApplicationDirty(false);
          this.$router.push({ name: 'roleManagement' });
        })
        .catch((error) => {
          this.handleError(error);
        });
    },
    copyRole(this: any) {
      const roleCopyModel = this.role as RoleCopyModel;
      roleCopyModel.copyRoleId = this.isCopy.id;
      RoleService.copyRoleAsync(roleCopyModel)
        .then((response) => {
          SnotifyConfiguration.showSuccess('Role copied successfully.');
          this.setApplicationDirty(false);
          this.$router.push({ name: 'roleManagement' });
        })
        .catch((error) => {
          this.handleError(error);
        });
    },
    handleError(error: any) {
      this.$validator.errors.remove('serverValidationErrors');
      this.$validator.errors.add({
        field: 'serverValidationErrors',
        msg: error.notification
      });
      this.isLoading = false;
    },
    async cancel(this: any) {
      this.$router.back();
    }
  },
  mounted() {
    RoleService.checkMaintenancePermissions();
  }
});
